import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AppThunk } from '../store'
import { getContactType, postContact } from '../../apis/contact'
import { setErrors } from '../common/errorsSlice'
import {
  GetContactTypeResponse,
  ContactType,
  ContactRequest,
  ContactTypeRequest,
} from '../../types/contact'

interface ContactState {
  contactTypes: ContactType[]
  type: number
  context: string
  message: string
  isLoading: boolean
}

const initialState: ContactState = {
  contactTypes: [],
  type: 0,
  context: '',
  message: '',
  isLoading: true,
}

const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    requestStart: (state) => {
      state.isLoading = true
      return state
    },
    getContactTypeSuccess: (state, action: PayloadAction<GetContactTypeResponse>) => {
      state.contactTypes = action.payload.contact_type
      state.isLoading = false
      return state
    },
    postContactSuccess: (state, action: PayloadAction<string>) => {
      state.message = action.payload
      state.isLoading = false
      return state
    },
    requestFailure: (state) => {
      state.isLoading = false
      return state
    },
  },
})

export const {
  requestStart,
  getContactTypeSuccess,
  postContactSuccess,
  requestFailure,
} = contactSlice.actions

export const contactReducer = contactSlice.reducer

export const fetchContact = (
  params: ContactTypeRequest,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getContactType(params)
    .then((result) => {
      dispatch(getContactTypeSuccess(result))
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const createContact = (
  params: ContactRequest,
  callback: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  postContact(params)
    .then((result) => {
      dispatch(postContactSuccess(result))
      callback()
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}
